export default __webpack_public_path__ + "static/hero-bg-min-1x-14c06b6719127c32a46e5a62db1e65cb.jpg";